<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="new" ttGoto="listdata" [ttGotoParms]="{ listdata_keyno: '0', list_keyno: listKeyno }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListDatas"></tt-list>
</tt-page>
